import type { RegistrationOutcomeKind } from "./successCopy";

/** Thank-you copy after standalone express registration (legacy `ExpressRegistrationForm`). */
export function expressRegistrationSuccessParagraphs(
  promptPassword: boolean,
  outcome: RegistrationOutcomeKind,
): string[] {
  const lines: string[] = [];

  if (promptPassword) {
    lines.push("You can open the Buxus app and sign in with the password you created.");
  } else {
    lines.push(
      "To sign in, first set your password by using the Forgot password? option in the Buxus app.",
    );
  }

  if (outcome === "pending") {
    lines.push(
      "Your account is awaiting verification. We typically confirm responder roles within one to two business days; you will receive an email when full access is granted.",
    );
  }

  lines.push("You will also receive a link later to complete the rest of your profile details.");

  return lines;
}
